export default __webpack_public_path__ + "static/media/store.dacc52b7.png";